<template>
    <form class="add-company-form" @submit="validateForm" ref="createCompanyForm" enctype="multipart/form-data">
        <!-- Plan Selection -->
        <div class="form-row" v-if="modalAdd">
            <div class="form-group">
                <label for="planData">Select Plan <span class="required">*</span></label>
                <multiselect 
                    v-model="chargebeeUser.planData" 
                    :options="plans" 
                    placeholder="Type to search for a plan" 
                    track-by="name" 
                    label="name"
                    class="plan-multiselect"
                >
                    <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                </multiselect>
            </div>
        </div>

        <!-- Company Information -->
        <div class="form-section">
            <h3 class="section-title">Company Information</h3>
            
            <div class="form-row">
                <div class="form-group">
                    <label for="companyname">Company/Organization Name <span class="required">*</span></label>
                    <input 
                        type="text" 
                        id="companyname" 
                        class="form-control" 
                        placeholder="Enter company name"
                        v-model="chargebeeUser.companyname"
                    >
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="domain">Company URL <span class="required">*</span></label>
                    <input 
                        type="text" 
                        id="companydomain" 
                        class="form-control" 
                        placeholder="Enter company website URL"
                        v-model="chargebeeUser.domain"
                    >
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="employees">Number of Employees <span class="required">*</span></label>
                    <input 
                        type="number" 
                        id="employees" 
                        class="form-control" 
                        placeholder="Enter number of employees"
                        v-model="chargebeeUser.employees"
                    >
                </div>
            </div>
        </div>

        <!-- Representative Information -->
        <div class="form-section">
            <h3 class="section-title">Representative Information</h3>
            
            <div class="form-row two-column">
                <div class="form-group">
                    <label for="first_name">First Name <span class="required">*</span></label>
                    <input 
                        type="text" 
                        id="first_name" 
                        class="form-control" 
                        placeholder="Enter first name"
                        v-model="chargebeeUser.first_name"
                    >
                </div>

                <div class="form-group">
                    <label for="last_name">Last Name <span class="required">*</span></label>
                    <input 
                        type="text" 
                        id="last_name" 
                        class="form-control" 
                        placeholder="Enter last name"
                        v-model="chargebeeUser.last_name"
                    >
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="email">Email <span class="required">*</span></label>
                    <input 
                        type="email" 
                        id="email" 
                        class="form-control" 
                        placeholder="Enter company representative email"
                        v-model="chargebeeUser.email"
                    >
                </div>
            </div>

            <div class="form-row two-column">
                <div class="form-group">
                    <label for="password">Password <span class="required">*</span></label>
                    <input 
                        type="password" 
                        id="password" 
                        class="form-control" 
                        placeholder="Enter password"
                        v-model="chargebeeUser.password"
                    >
                </div>

                <div class="form-group">
                    <label for="cpassword">Confirm Password <span class="required">*</span></label>
                    <input 
                        type="password" 
                        id="cpassword" 
                        class="form-control" 
                        placeholder="Confirm password"
                        v-model="chargebeeUser.cpassword"
                    >
                    <input type="hidden" v-model="chargebeeUser.email_password_detail">
                </div>
            </div>
        </div>

        <!-- Learning Plan Information -->
        <div class="form-section" v-if="modalAdd">
            <h3 class="section-title">Learning Plan Details</h3>
            
            <div class="form-row">
                <div class="form-group">
                    <label for="duration">General Learning Plan Interval Duration</label>
                    <select 
                        id="duration" 
                        class="form-control" 
                        v-model="chargebeeUser.duration"
                    >
                        <option value="">--Select--</option>
                        <option value="1">1 Day</option>
                        <option value="2">2 Days</option>
                        <option value="3">3 Days</option>
                        <option value="21">3 Weeks</option>
                        <option value="28">4 Weeks</option>
                        <option value="35">5 Weeks</option>
                        <option value="42">6 Weeks</option>
                        <option value="56">8 Weeks</option>
                        <option value="70">10 Weeks</option>
                        <option value="84">12 Weeks</option>
                    </select>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label for="learning_plan_start_date">General Learning Plan Start Date</label>
                    <input 
                        type="date" 
                        id="learning_plan_start_date" 
                        class="form-control"
                        v-model="chargebeeUser.learning_plan_start_date"
                    >
                </div>
            </div>
        </div>

        <div class="form-actions">
            <button 
                type="submit" 
                class="submit-btn" 
                :disabled="chargebeeUser.disabled"
            >
                <span v-if="chargebeeUser.disabled">Submitting...</span>
                <span v-else>Submit</span>
            </button>
        </div>
    </form>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style scoped>
.add-company-form {
  max-width: 100%;
  margin: 0 auto;
  padding: 0.5rem;
}

.form-section {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eaeaea;
}

.form-section:last-of-type {
  border-bottom: none;
}

.section-title {
  font-size: 1.1rem;
  color: #0A0446;
  margin-bottom: 1.25rem;
  font-weight: 600;
}

.form-row {
  margin-bottom: 1.25rem;
}

.form-row:last-of-type {
  margin-bottom: 0;
}

.two-column {
  display: flex;
  gap: 1rem;
}

.form-group {
  flex: 1;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #212529;
  font-size: 0.95rem;
}

.required {
  color: #dc3545;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.75rem;
  font-size: 0.95rem;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.plan-multiselect {
  margin-bottom: 0.5rem;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.submit-btn {
  background-color: #BE0858;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 0.75rem 2.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.submit-btn:hover:not(:disabled) {
  background-color: #a7074e;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .two-column {
    flex-direction: column;
    gap: 1.25rem;
  }
}
</style>

<script>
/* eslint-disable */
import AppMixin from '../../../mixins/AppMixin'
import Api from '../../../router/api'
import axios from 'axios'

export default {
    name: 'Add',
    mixins: [AppMixin],
    props: [
        'modalAdd'
    ],
    data() {
        return {
            chargebeeUser: {
                'companyname': '',
                'email': '',
                'password': '',
                'cpassword':'',
                'email_password_detail':0,
                'first_name':'',
                'last_name':'',
                'domain': '',
                'employees': '',
                'plan': '',
                'addon': '',
                'logo': '',
                'disabled': false,
                'periodUnit': '',
                'planType': '',
                'planData': '',
                "duration":'',
                "learning_plan_start_date":'',
            },
            subscriptionPlans: [],
            hideFooter: true,
            plans: [],
            url:'',
            formErrors: []
        }
    },
    methods: {
        fileOnChange: function (e) {
            let that = this;
            this.chargebeeUser.logo = this.$refs.logo.files[0];
            this.url = URL.createObjectURL(e.target.files[0]);
        },
        validateForm: function (e) {
            e.preventDefault();
            let that = this;
            
            // Reset errors
            this.formErrors = [];
            
            if (that.modalAdd != 1) {
                this.chargebeeUser.plan = this.$route.query.plan
                this.chargebeeUser.periodUnit = this.$route.query.periodUnit
                this.chargebeeUser.planType = this.$route.query.itemId
            }
            else {
                if (!this.chargebeeUser.planData) {
                    this.formErrors.push('Please select a plan');
                } else {
                    this.chargebeeUser.plan = this.chargebeeUser.planData.id
                    this.chargebeeUser.periodUnit = this.chargebeeUser.planData.periodUnit
                    this.chargebeeUser.planType = this.chargebeeUser.planData.itemId
                }
            }

            if (!that.chargebeeUser.plan) {
                this.$swal({
                    icon: "error",
                    title: "Error",
                    text: "Please select a plan from plans page",
                    showConfirmButton: true
                });
                return;
            }
            
            if (!that.chargebeeUser.companyname) {
                this.formErrors.push('Company name is required');
            }
            
            if (!that.chargebeeUser.first_name) {
                this.formErrors.push('First name is required');
            }
            
            if (!that.chargebeeUser.last_name) {
                this.formErrors.push('Last name is required');
            }
            
            if (!that.chargebeeUser.email) {
                this.formErrors.push('Email is required');
            } else if (!this.validateEmail(that.chargebeeUser.email)) {
                this.formErrors.push('Please enter a valid email address');
            }
            
            if (!that.chargebeeUser.password) {
                this.formErrors.push('Password is required');
            }
            
            if (!that.chargebeeUser.cpassword) {
                this.formErrors.push('Confirm password is required');
            } else if (that.chargebeeUser.password !== that.chargebeeUser.cpassword) {
                this.formErrors.push('Passwords do not match');
            }
            
            if (!that.chargebeeUser.domain) {
                this.formErrors.push('Company URL is required');
            }
            
            if (!that.chargebeeUser.employees) {
                this.formErrors.push('Number of employees is required');
            }
            
            // If there are errors, show them and stop
            if (this.formErrors.length > 0) {
                this.$swal({
                    icon: "error",
                    title: "Please fix the following errors:",
                    html: this.formErrors.join('<br>'),
                    showConfirmButton: true
                });
                return;
            }

            // All validation passed, proceed with submission
            that.chargebeeUser.disabled = true;
            const formData = new FormData();
            formData.append('companyname', that.chargebeeUser.companyname);
            formData.append('first_name', that.chargebeeUser.first_name);
            formData.append('last_name', that.chargebeeUser.last_name);
            formData.append('email', that.chargebeeUser.email);
            formData.append('password', that.chargebeeUser.password);
            formData.append('email_password_detail', that.chargebeeUser.email_password_detail);
            formData.append('domain', that.chargebeeUser.domain);
            formData.append('employees', that.chargebeeUser.employees);
            formData.append('plan', that.chargebeeUser.plan);
            formData.append('periodUnit', that.chargebeeUser.periodUnit);
            formData.append('planType', that.chargebeeUser.planType);
            formData.append('addon', that.chargebeeUser.addon);
            formData.append('duration', that.chargebeeUser.duration);
            formData.append('learning_plan_start_date', that.chargebeeUser.learning_plan_start_date);
            formData.append('logo', that.chargebeeUser.logo);
            
            axios.post(APP_URL + '/create-company', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Access-Control-Allow-Origin': '*'
                    }
                }).then(response => {
                    this.$swal({
                        icon: "success",
                        title: "Success",
                        text: "Company created successfully",
                        showConfirmButton: true
                    }).then(() => {
                        that.chargebeeUser.disabled = false;
                        // Emit event to parent to close modal and refresh list
                        this.$emit('company-added');
                        
                        // Reset form
                        this.resetForm();
                        
                        if (!that.modalAdd) {
                            this.$router.push('/admin/companies');
                        }
                    });
                }).catch((error) => {
                    that.chargebeeUser.disabled = false;
                    this.$swal({
                        icon: "error",
                        title: "Error",
                        text: error.response.data.message,
                        showConfirmButton: true
                    });
                });
        },
        getPlans: function () {
            let that = this;
            Api.getPlans2().then(response => {
                that.plans = response.data.res
            }).catch((error) => {
                console.error("Failed to fetch plans:", error);
            });
        },
        validateEmail: function(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        resetForm: function() {
            this.chargebeeUser = {
                'companyname': '',
                'email': '',
                'password': '',
                'cpassword':'',
                'email_password_detail': this.isLoggedIn ? 1 : 0,
                'first_name':'',
                'last_name':'',
                'domain': '',
                'employees': '',
                'plan': '',
                'addon': '',
                'logo': '',
                'disabled': false,
                'periodUnit': '',
                'planType': '',
                'planData': '',
                "duration":'',
                "learning_plan_start_date":'',
            };
            this.formErrors = [];
        }
    },
    created() {
        this.getPlans();
    },
    mounted() {
        if (this.isLoggedIn) {
            this.chargebeeUser.email_password_detail = 1;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/common/companies/Add.vue